import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("{{! @glint-nocheck: not typesafe yet }}\n<li\n  aria-label={{t \"drafts.components.post-list.card.aria.draft_post\"}}\n  class={{concat-classes (if this.shouldApplyErrorClass \"has--error\") \"cPL--card qa--post_card\"}}\n  tabindex=\"0\"\n>\n  {{#if @post.hasError}}\n    <div class={{this.errorClass}}>\n      {{svg-jar \"danger\" class=\"o--icon cPL--cardBanner__icon\"}}\n      <div>\n        <h5 class=\"cPL--cardBanner__title\">{{t \"list.components.post-list.card.error.title\"}}</h5>\n        <p class=\"cPL--cardBanner__desc\">\n          {{#if @post.modalErrorText}}\n            {{@post.modalErrorText}}\n            {{html-safe @post.formattedPlatformError}}\n          {{else}}\n            {{this.defaultPostError}}\n          {{/if}}\n        </p>\n      </div>\n    </div>\n  {{/if}}\n\n  {{#if @post.canBoostPost}}\n    <div class=\"cPL--cardHeader u--flex__justify--end\">\n      <Shared::Button::Boost\n        @class=\"o--btn--r qa--post_boostPost_btn at--boostPost__btn--listView\"\n        @location=\"list_view\"\n        @post={{@post}}\n      />\n    </div>\n  {{/if}}\n\n  <div class=\"cPL--cardHeader\">\n    <div class=\"cPL--cardHeader__section\">\n      <div aria-label={{t \"shared_phrases.social_profile\"}} class=\"cPL--cardHeader__profile\" role=\"group\" tabindex=\"0\">\n        <Shared::ProfileAvatar\n          @showDetails={{true}}\n          @showOutline={{true}}\n          @showPlatform={{true}}\n          @socialProfile={{@post.socialProfile}}\n          aria-label={{@post.socialProfile.profileType}}\n          class=\"cPL--cardHeader__user\"\n          tabindex=\"0\"\n        />\n      </div>\n    </div>\n    <div class=\"cPL--cardHeader__section\">\n      <p\n        aria-label={{t \"drafts.components.post-list.card.label.selected_time\"}}\n        class=\"cPL--cardHeader__selectedTime qa--post_selectedTime\"\n        role=\"group\"\n        tabindex=\"0\"\n      >\n        {{#if this.shouldApplyErrorClass}}\n          {{svg-jar \"danger\" class=\"o--icon--sm o--icon--danger u--m__r__xs\"}}\n        {{else if @post.isPosted}}\n          {{svg-jar \"verified\" class=\"o--icon--sm o--icon--success u--m__r__xs\"}}\n        {{else if this.publishingIcon}}\n          {{svg-jar this.publishingIcon class=\"o--icon--sm u--m__r__xs qa--post_postTypeIcon\"}}\n        {{/if}}\n        <span>\n          {{t \"drafts.components.post-list.card.label.selected_time\"}}\n        </span>\n        <span tabindex=\"0\">\n          {{this.selectedTime}}\n        </span>\n      </p>\n      <div class=\"cPL--cardHeader__actionBtn\" tabindex=\"-1\">\n        <Shared::Ui::Button\n          @additional=\"circle\"\n          @onClick={{toggle-action \"showCopyPostModal\" this}}\n          @variant=\"outline\"\n          aria-label={{t \"post.copy_post.copy_post\"}}\n          class=\"qa--post_copyBtn\"\n          type=\"button\"\n        >\n          {{svg-jar \"copy\" class=\"o--icon o--icon-lg\"}}\n          <EmberTooltip @event=\"hover\">\n            {{t \"post.copy_post.copy_post\"}}\n          </EmberTooltip>\n        </Shared::Ui::Button>\n      </div>\n      {{#unless @post.isPosted}}\n        <div class=\"cPL--cardHeader__actionBtn\" tabindex=\"-1\">\n          <Shared::Ui::Button\n            @additional=\"circle\"\n            @onClick={{this.onClickEditButton}}\n            @variant=\"outline\"\n            aria-label={{t \"drafts.components.post-list.card.aria.edit_post\"}}\n            class=\"qa--post_editBtn\"\n            type=\"button\"\n          >\n            {{svg-jar \"edit\" class=\"o--icon o--icon-lg\"}}\n            <EmberTooltip @event=\"hover\">\n              {{t \"drafts.components.post-list.card.aria.edit_post\"}}\n            </EmberTooltip>\n          </Shared::Ui::Button>\n        </div>\n      {{/unless}}\n    </div>\n  </div>\n\n  <div class=\"cPL--cardBody\">\n    {{#unless this.hasNoMedia}}\n      {{! Media }}\n      <div class=\"cPL--cardBody__media {{if this.hasTallImage 'cPL--cardBody__media--tall'}}\">\n        <LinkTo\n          @loadingClass=\"\"\n          @model={{@post.id}}\n          @query={{this.editRouteParams}}\n          @route={{@editRoute}}\n          aria-label={{this.captionLabel}}\n          role=\"link\"\n          tabindex=\"0\"\n        >\n          <figure class=\"o--mediaContainer\">\n            {{#if this.mediaIcon}}\n              <span class=\"o--media__label--type\">\n                {{svg-jar this.mediaIcon class=\"o--icon--md o--icon--white\"}}\n              </span>\n            {{/if}}\n            <Shared::Image\n              @picture={{hash sources=this.imageUrl}}\n              alt={{@post.caption}}\n              class=\"o--media\"\n              onerror={{this.onImageError}}\n            />\n            <b class=\"o--mediaOverlay\"></b>\n          </figure>\n        </LinkTo>\n      </div>\n    {{/unless}}\n    <div class=\"cPL--cardBody__detailWrapper\">\n\n      {{! Post Details: Required Fields }}\n      <div class=\"cPL--cardBody__detail\">\n        <Schedule::PostList::PostDetails @captionLabel={{this.captionLabel}} @post={{@post}} />\n      </div>\n      {{! Post Details: Optional Fields }}\n      {{#if this.showAddedOptions}}\n        <div\n          aria-label={{t \"drafts.components.post-list.card.label.added_options\"}}\n          class=\"cPL--cardBody__detail\"\n          role=\"group\"\n          tabindex=\"0\"\n        >\n          <h5 class=\"cPL--cardBody__title qa--post_addedOptions_title\">\n            {{t \"drafts.components.post-list.card.label.added_options\"}}\n          </h5>\n          <ul class=\"cPL--cardBody__optionList qa--post_addedOptions_list\">\n            {{#if this.addedOptions.length}}\n              {{#each this.addedOptions as |option|}}\n                <li class={{concat-classes \"cPL--cardBody__option\" (if option.class option.class)}}>\n                  {{svg-jar option.icon class=\"o--icon o--icon--sm\"}}\n                  <span tabindex=\"0\">\n                    {{option.label}}\n                  </span>\n                </li>\n              {{/each}}\n            {{else}}\n              -{{! Empty indicator }}\n            {{/if}}\n          </ul>\n        </div>\n      {{/if}}\n    </div>\n  </div>\n\n  {{! Footer }}\n  {{#if this.displayFooter}}\n    <div class=\"cPL--cardFooter\">\n      <Schedule::PostList::Tags @tagList={{this.tagList}} />\n      <div class=\"cPL--footerButtons\">\n        {{#if this.displayApproveButton}}\n          {{#if this.needsUpgrade}}\n            <Shared::Button::Upgrade @feature={{\"approverRoles\"}} @location=\"list view footer\" as |upgradeAction|>\n              <Shared::Ui::Button @onClick={{upgradeAction}} @variant=\"default\" class=\"qa--post_ApproveBtn\">\n                {{svg-jar \"check\" class=\"o--icon\"}}\n                {{t \"shared_words.approve\"}}\n              </Shared::Ui::Button>\n            </Shared::Button::Upgrade>\n          {{else}}\n            <Shared::Ui::Button @class=\"qa--post_ApproveBtn\" @promise={{this.approvePost}} @variant=\"default\">\n              {{svg-jar \"check\" class=\"o--icon\"}}\n              {{t \"shared_words.approve\"}}\n            </Shared::Ui::Button>\n          {{/if}}\n        {{/if}}\n        {{#if this.displayRequestChangesButton}}\n          <Shared::Ui::Button @class=\"qa--post_request_changesBtn\" @onClick={{this.requestChanges}} @variant=\"outline\">\n            {{svg-jar \"comment\" class=\"o--icon\"}}\n            {{t \"approval.list.card.buttons.request_changes\"}}\n          </Shared::Ui::Button>\n        {{/if}}\n      </div>\n    </div>\n  {{/if}}\n</li>\n{{#if this.showCopyPostModal}}\n  <Shared::Post::Copy::Modal @closeModal={{toggle-action \"showCopyPostModal\" this}} @post={{@post}} />\n{{/if}}", {"contents":"{{! @glint-nocheck: not typesafe yet }}\n<li\n  aria-label={{t \"drafts.components.post-list.card.aria.draft_post\"}}\n  class={{concat-classes (if this.shouldApplyErrorClass \"has--error\") \"cPL--card qa--post_card\"}}\n  tabindex=\"0\"\n>\n  {{#if @post.hasError}}\n    <div class={{this.errorClass}}>\n      {{svg-jar \"danger\" class=\"o--icon cPL--cardBanner__icon\"}}\n      <div>\n        <h5 class=\"cPL--cardBanner__title\">{{t \"list.components.post-list.card.error.title\"}}</h5>\n        <p class=\"cPL--cardBanner__desc\">\n          {{#if @post.modalErrorText}}\n            {{@post.modalErrorText}}\n            {{html-safe @post.formattedPlatformError}}\n          {{else}}\n            {{this.defaultPostError}}\n          {{/if}}\n        </p>\n      </div>\n    </div>\n  {{/if}}\n\n  {{#if @post.canBoostPost}}\n    <div class=\"cPL--cardHeader u--flex__justify--end\">\n      <Shared::Button::Boost\n        @class=\"o--btn--r qa--post_boostPost_btn at--boostPost__btn--listView\"\n        @location=\"list_view\"\n        @post={{@post}}\n      />\n    </div>\n  {{/if}}\n\n  <div class=\"cPL--cardHeader\">\n    <div class=\"cPL--cardHeader__section\">\n      <div aria-label={{t \"shared_phrases.social_profile\"}} class=\"cPL--cardHeader__profile\" role=\"group\" tabindex=\"0\">\n        <Shared::ProfileAvatar\n          @showDetails={{true}}\n          @showOutline={{true}}\n          @showPlatform={{true}}\n          @socialProfile={{@post.socialProfile}}\n          aria-label={{@post.socialProfile.profileType}}\n          class=\"cPL--cardHeader__user\"\n          tabindex=\"0\"\n        />\n      </div>\n    </div>\n    <div class=\"cPL--cardHeader__section\">\n      <p\n        aria-label={{t \"drafts.components.post-list.card.label.selected_time\"}}\n        class=\"cPL--cardHeader__selectedTime qa--post_selectedTime\"\n        role=\"group\"\n        tabindex=\"0\"\n      >\n        {{#if this.shouldApplyErrorClass}}\n          {{svg-jar \"danger\" class=\"o--icon--sm o--icon--danger u--m__r__xs\"}}\n        {{else if @post.isPosted}}\n          {{svg-jar \"verified\" class=\"o--icon--sm o--icon--success u--m__r__xs\"}}\n        {{else if this.publishingIcon}}\n          {{svg-jar this.publishingIcon class=\"o--icon--sm u--m__r__xs qa--post_postTypeIcon\"}}\n        {{/if}}\n        <span>\n          {{t \"drafts.components.post-list.card.label.selected_time\"}}\n        </span>\n        <span tabindex=\"0\">\n          {{this.selectedTime}}\n        </span>\n      </p>\n      <div class=\"cPL--cardHeader__actionBtn\" tabindex=\"-1\">\n        <Shared::Ui::Button\n          @additional=\"circle\"\n          @onClick={{toggle-action \"showCopyPostModal\" this}}\n          @variant=\"outline\"\n          aria-label={{t \"post.copy_post.copy_post\"}}\n          class=\"qa--post_copyBtn\"\n          type=\"button\"\n        >\n          {{svg-jar \"copy\" class=\"o--icon o--icon-lg\"}}\n          <EmberTooltip @event=\"hover\">\n            {{t \"post.copy_post.copy_post\"}}\n          </EmberTooltip>\n        </Shared::Ui::Button>\n      </div>\n      {{#unless @post.isPosted}}\n        <div class=\"cPL--cardHeader__actionBtn\" tabindex=\"-1\">\n          <Shared::Ui::Button\n            @additional=\"circle\"\n            @onClick={{this.onClickEditButton}}\n            @variant=\"outline\"\n            aria-label={{t \"drafts.components.post-list.card.aria.edit_post\"}}\n            class=\"qa--post_editBtn\"\n            type=\"button\"\n          >\n            {{svg-jar \"edit\" class=\"o--icon o--icon-lg\"}}\n            <EmberTooltip @event=\"hover\">\n              {{t \"drafts.components.post-list.card.aria.edit_post\"}}\n            </EmberTooltip>\n          </Shared::Ui::Button>\n        </div>\n      {{/unless}}\n    </div>\n  </div>\n\n  <div class=\"cPL--cardBody\">\n    {{#unless this.hasNoMedia}}\n      {{! Media }}\n      <div class=\"cPL--cardBody__media {{if this.hasTallImage 'cPL--cardBody__media--tall'}}\">\n        <LinkTo\n          @loadingClass=\"\"\n          @model={{@post.id}}\n          @query={{this.editRouteParams}}\n          @route={{@editRoute}}\n          aria-label={{this.captionLabel}}\n          role=\"link\"\n          tabindex=\"0\"\n        >\n          <figure class=\"o--mediaContainer\">\n            {{#if this.mediaIcon}}\n              <span class=\"o--media__label--type\">\n                {{svg-jar this.mediaIcon class=\"o--icon--md o--icon--white\"}}\n              </span>\n            {{/if}}\n            <Shared::Image\n              @picture={{hash sources=this.imageUrl}}\n              alt={{@post.caption}}\n              class=\"o--media\"\n              onerror={{this.onImageError}}\n            />\n            <b class=\"o--mediaOverlay\"></b>\n          </figure>\n        </LinkTo>\n      </div>\n    {{/unless}}\n    <div class=\"cPL--cardBody__detailWrapper\">\n\n      {{! Post Details: Required Fields }}\n      <div class=\"cPL--cardBody__detail\">\n        <Schedule::PostList::PostDetails @captionLabel={{this.captionLabel}} @post={{@post}} />\n      </div>\n      {{! Post Details: Optional Fields }}\n      {{#if this.showAddedOptions}}\n        <div\n          aria-label={{t \"drafts.components.post-list.card.label.added_options\"}}\n          class=\"cPL--cardBody__detail\"\n          role=\"group\"\n          tabindex=\"0\"\n        >\n          <h5 class=\"cPL--cardBody__title qa--post_addedOptions_title\">\n            {{t \"drafts.components.post-list.card.label.added_options\"}}\n          </h5>\n          <ul class=\"cPL--cardBody__optionList qa--post_addedOptions_list\">\n            {{#if this.addedOptions.length}}\n              {{#each this.addedOptions as |option|}}\n                <li class={{concat-classes \"cPL--cardBody__option\" (if option.class option.class)}}>\n                  {{svg-jar option.icon class=\"o--icon o--icon--sm\"}}\n                  <span tabindex=\"0\">\n                    {{option.label}}\n                  </span>\n                </li>\n              {{/each}}\n            {{else}}\n              -{{! Empty indicator }}\n            {{/if}}\n          </ul>\n        </div>\n      {{/if}}\n    </div>\n  </div>\n\n  {{! Footer }}\n  {{#if this.displayFooter}}\n    <div class=\"cPL--cardFooter\">\n      <Schedule::PostList::Tags @tagList={{this.tagList}} />\n      <div class=\"cPL--footerButtons\">\n        {{#if this.displayApproveButton}}\n          {{#if this.needsUpgrade}}\n            <Shared::Button::Upgrade @feature={{\"approverRoles\"}} @location=\"list view footer\" as |upgradeAction|>\n              <Shared::Ui::Button @onClick={{upgradeAction}} @variant=\"default\" class=\"qa--post_ApproveBtn\">\n                {{svg-jar \"check\" class=\"o--icon\"}}\n                {{t \"shared_words.approve\"}}\n              </Shared::Ui::Button>\n            </Shared::Button::Upgrade>\n          {{else}}\n            <Shared::Ui::Button @class=\"qa--post_ApproveBtn\" @promise={{this.approvePost}} @variant=\"default\">\n              {{svg-jar \"check\" class=\"o--icon\"}}\n              {{t \"shared_words.approve\"}}\n            </Shared::Ui::Button>\n          {{/if}}\n        {{/if}}\n        {{#if this.displayRequestChangesButton}}\n          <Shared::Ui::Button @class=\"qa--post_request_changesBtn\" @onClick={{this.requestChanges}} @variant=\"outline\">\n            {{svg-jar \"comment\" class=\"o--icon\"}}\n            {{t \"approval.list.card.buttons.request_changes\"}}\n          </Shared::Ui::Button>\n        {{/if}}\n      </div>\n    </div>\n  {{/if}}\n</li>\n{{#if this.showCopyPostModal}}\n  <Shared::Post::Copy::Modal @closeModal={{toggle-action \"showCopyPostModal\" this}} @post={{@post}} />\n{{/if}}","moduleName":"later/components/schedule/post-list/card.hbs","parseOptions":{"srcName":"later/components/schedule/post-list/card.hbs"}});
import { assert } from '@ember/debug';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import moment from 'moment';

import { GramState } from 'later/models/gram';
import { SECONDARY_MODAL_TYPES } from 'later/utils/constants';
import { SegmentEventTypes } from 'later/utils/constants/segment-events';
import uuid from 'shared/utils/uuid';

import type RouterService from '@ember/routing/router-service';
import type IntlService from 'ember-intl/services/intl';
import type GramModel from 'later/models/gram';
import type PostMediaItemModel from 'later/models/post-media-item';
import type AlertsService from 'later/services/alerts';
import type AuthService from 'later/services/auth';
import type ErrorsService from 'later/services/errors';
import type PostsPendingApprovalService from 'later/services/schedule/posts-pending-approval';
import type SecondaryModalService from 'later/services/secondary-modal';
import type SegmentService from 'later/services/segment';
import type UserRoleService from 'later/services/user-role';
import type { Maybe, Transition } from 'shared/types';

interface PostOption {
  icon: string;
  label: string;
  class?: string;
}

interface PostListCardComponentArgs {
  post: GramModel;
  editRoute: string;
}

export default class PostListCardComponent extends Component<PostListCardComponentArgs> {
  @service declare alerts: AlertsService;
  @service declare auth: AuthService;
  @service declare errors: ErrorsService;
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service('schedule/posts-pending-approval') declare postsPendingApproval: PostsPendingApprovalService;
  @service declare secondaryModal: SecondaryModalService;
  @service declare segment: SegmentService;
  @service declare userRole: UserRoleService;

  @tracked showCopyPostModal = false;

  uniqueId = uuid();

  constructor(owner: unknown, args: PostListCardComponentArgs) {
    super(owner, args);
    assert('`post` is required', typeof args.post === 'object');
    assert('`editRoute` is required', typeof args.editRoute === 'string');
  }

  get captionLabel(): string {
    if (this.isDescription) {
      return this.intl.t('post.caption.description_title');
    } else if (this.args.post.isThreads) {
      return this.intl.t('post.caption.threads_title');
    }
    return this.intl.t('post.caption.title');
  }

  get defaultPostError(): string {
    return this.intl.t('list.components.post-list.card.error.default');
  }

  get displayFooter(): boolean {
    return Boolean(this.tagList.length || this.displayApproveButton || this.displayRequestChangesButton);
  }

  get errorClass(): string {
    if (this.args.post.isDraft) {
      return 'cPL--cardBanner--error is--draft';
    }

    if (this.args.post.state === GramState.Failed) {
      return 'cPL--cardBanner--error';
    }

    // Note: Default error class
    return 'cPL--cardBanner--error';
  }

  get hasNoMedia(): boolean {
    return Boolean(this.args.post.isText || !this.args.post.postMediaItems.length);
  }

  get imageUrl(): Maybe<string> {
    return this.args.post.isReel && this.args.post.customCoverPMI
      ? this.args.post.medThumbnailOrMediaMedThumbnail
      : this.args.post.previewUrl;
  }

  get isDescription(): boolean {
    return this.args.post.isPinterest || this.args.post.isYoutube;
  }

  get selectedTime(): string {
    const { scheduledTime } = this.args.post;
    if (!scheduledTime) {
      throw new Error("Unable to use gram's `scheduledTime` to display `selectedTime`");
    }

    return moment.unix(scheduledTime).format('MMM Do YYYY - h:mm A');
  }

  get shouldApplyErrorClass(): boolean {
    return Boolean(this.args.post.hasError && this.args.post.state === GramState.Failed);
  }

  get mediaIcon(): string {
    const { isTiktok, isReel, isCarouselPost, isVideo, isInstagramStory } = this.args.post;
    if (isInstagramStory) {
      return 'ig-story';
    } else if (isTiktok) {
      return 'lib-tiktok';
    } else if (isReel) {
      return 'ig-reels';
    } else if (isCarouselPost) {
      return 'gallery';
    } else if (isVideo) {
      return 'video';
    }
    return '';
  }

  get publishingIcon(): 'instant' | 'notification' {
    if (this.args.post.isNotificationPost) {
      return 'notification';
    }

    return 'instant';
  }

  get postMediaItemsWithProductTags(): PostMediaItemModel[] {
    return this.args.post.postMediaItems.filter((postMediaItem) => Boolean(postMediaItem.productTags?.length));
  }

  get hasClickTracking(): boolean {
    return Boolean(this.args.post.clickTracking);
  }

  get hasLocation(): boolean {
    return Boolean(this.args.post.locationId);
  }

  get hasFirstComment(): boolean {
    return Boolean(this.args.post.isFirstCommentActive);
  }

  get hasLinkinBio(): boolean {
    return Boolean(this.args.post.linkinbioPost?.get('id'));
  }

  get hasPinterestLinkUrl(): boolean {
    return Boolean(this.args.post.isPinterest && this.args.post.linkUrl);
  }

  get hasTaggedUsers(): boolean {
    return Boolean(this.args.post.taggedUsers?.length > 0);
  }

  get hasTaggedProducts(): boolean {
    return Boolean(this.postMediaItemsWithProductTags?.length > 0);
  }

  get hasTallImage(): boolean {
    return Boolean(
      this.args.post.isTiktok || this.args.post.isReel || this.args.post.isYoutube || this.args.post.isInstagramStory
    );
  }

  get hasKeywordTags(): boolean {
    return Boolean(this.args.post.keywordTags?.length);
  }

  get hasVideoCategory(): boolean {
    return Boolean(this.args.post.category);
  }

  get hasNotifySubscribersOn(): boolean {
    return this.args.post.notifySubscribers;
  }

  get hasSaveToProfile(): boolean {
    return Boolean(this.args.post.saveToProfile);
  }

  get showAddedOptions(): boolean {
    const { isFacebook, isLinkedin } = this.args.post;
    if (isFacebook || isLinkedin) {
      return false;
    }

    return true;
  }

  get addedOptions(): PostOption[] {
    const options: PostOption[] = [];

    if (this.hasFirstComment) {
      options.push({
        icon: 'first-comment',
        label: this.intl.t('post.body.first_comment'),
        class: 'qa--post_addedOptions_option_firstComment'
      });
    }
    if (this.hasLinkinBio) {
      options.push({
        icon: 'linkin-bio',
        label: this.intl.t('shared_words.linkinbio'),
        class: 'qa--post_addedOptions_option_linkinBio'
      });
    }
    if (this.hasPinterestLinkUrl) {
      options.push({
        icon: 'link',
        label: this.intl.t('post.body.website'),
        class: 'qa--post_addedOptions_option_website'
      });
    }
    if (this.hasLocation) {
      options.push({
        icon: 'location',
        label: this.intl.t('post.body.location'),
        class: 'qa--post_addedOptions_option_location'
      });
    }
    if (this.hasTaggedUsers) {
      options.push({
        icon: 'tag-user',
        label: this.intl.t('shared_phrases.tag_users'),
        class: 'qa--post_addedOptions_option_tagUser'
      });
    }
    if (this.hasTaggedProducts) {
      options.push({
        icon: 'tag-product',
        label: this.intl.t('shared_phrases.tag_products'),
        class: 'qa--post_addedOptions_option_tagProduct'
      });
    }
    if (this.hasClickTracking) {
      options.push({
        icon: 'link',
        label: this.intl.t('post.body.click_tracking'),
        class: 'qa--post_addedOptions_option_clickTracking'
      });
    }
    if (this.hasSaveToProfile) {
      options.push({
        icon: 'save',
        label: this.intl.t('post.body.snapchat.save_to_profile'),
        class: 'qa--post_addedOptions_option_saveToProfile'
      });
    }
    if (this.hasKeywordTags) {
      options.push({
        icon: 'label',
        label: this.intl.t('post.youtube.tags.label'),
        class: 'qa--post_addedOptions_option_keywordTags'
      });
    }
    if (this.hasVideoCategory) {
      options.push({
        icon: 'category',
        label: this.intl.t('post.youtube.category.label'),
        class: 'qa--post_addedOptions_option_videoCategory'
      });
    }
    if (this.hasNotifySubscribersOn) {
      options.push({
        icon: 'notify',
        label: this.intl.t('post.notify_subscribers.label'),
        class: 'qa--post_addedOptions_option_notifySubscribers'
      });
    }

    return options;
  }

  get editRouteParams(): object {
    return {
      draft: true,
      backTo: 'cluster.schedule.list'
    };
  }

  get tagConditions(): {
    condition: boolean;
    title: string;
    class: string;
    displayNotificationDot?: boolean;
    icon?: string;
  }[] {
    return [
      {
        condition: Boolean(this.args.post.isDraft),
        title: this.intl.t('shared_words.draft'),
        class: 'is--draft'
      },
      {
        condition: this.isApproved,
        title: this.intl.t('shared_words.approved'),
        class: 'is--approved qa--post_approved_tag',
        icon: 'check'
      },
      {
        condition: this.isPendingApproval,
        title: this.intl.t('approval.list.card.tags.unapproved'),
        class: 'is--pendingApproval qa--post_submitted_for_review_tag',
        displayNotificationDot: true,
        icon: 'warning'
      }
    ];
  }

  get tagList(): { title: string; class: string; displayNotificationDot?: boolean; icon?: string }[] {
    return this.tagConditions
      .filter((tag) => tag.condition)
      .map((tag) => ({
        title: tag.title,
        class: tag.class,
        displayNotificationDot: tag.displayNotificationDot,
        icon: tag.icon
      }));
  }

  get displayApprovalComponents(): boolean {
    return Boolean(this.auth.currentAccount.canApprovalFlow) && Boolean(this.args.post.approvalSubmittedTime);
  }

  get isApproved(): boolean {
    return this.displayApprovalComponents && this.args.post.isApproved;
  }

  get isPendingApproval(): boolean {
    return this.displayApprovalComponents && Boolean(this.args.post.pendingApproval) && this.args.post.isEditable;
  }

  get displayApproveButton(): boolean {
    return (this.isPendingApproval && this.userRole.currentUser.isApprover) || this.needsUpgrade;
  }

  get needsUpgrade(): boolean {
    return !this.auth.currentAccount.canApprovalFlow && Boolean(this.args.post.pendingApproval);
  }

  get displayRequestChangesButton(): boolean {
    return Boolean(this.auth.currentAccount.canUsePostActivityLog);
  }

  @action
  onClickEditButton(): void {
    const { editRouteParams: queryParams } = this;
    this.router.transitionTo(this.args.editRoute, this.args.post.id, { queryParams }) as Transition;
  }

  @action
  requestChanges(): void {
    const queryParams = { ...this.editRouteParams, postElementId: this.uniqueId };
    this.secondaryModal.toggleModal(this.uniqueId, SECONDARY_MODAL_TYPES.ACTIVITY, SECONDARY_MODAL_TYPES.ACTIVITY);
    this.segment.track(SegmentEventTypes.OpenedActivityPanel, {
      post_id: this.args.post.id
    });
    this.router.transitionTo(this.args.editRoute, this.args.post.id, { queryParams }) as Transition;
  }

  @action
  onImageError(error: Error): void {
    this.errors.log(error);
  }

  approvePost = task(async () => {
    if (!this.userRole.currentUser.isApprover) {
      this.errors.log("User can't approve post");
      return;
    }

    try {
      await this.args.post.approve();
      this.postsPendingApproval.fetchCount.perform();
      this.alerts.success(this.intl.t('alerts.approval.post-modal.success.message'), {
        title: this.intl.t('alerts.approval.post-modal.success.title')
      });
    } catch (error) {
      this.alerts.warning(this.intl.t('alerts.generic_error_message'));
      this.errors.log('Approve Post Error', error);
    }
  });
}
